// ── האזורים שאין בהם התחברות משרדית ─────────────────────────────────────────
//
// The kiosks, the crew's phone and the customer portal each have their own
// door: a badge, a job code, a customer login. None of their users can pass a
// staff login, which is why `ApiAuthGuard` refuses to send them to one.
//
// The list lived inside that guard, and a SECOND piece of code depended on it
// without being able to see it. `messageOf` in `saveErrors.ts` swallowed every
// 401 with the reasoning "ApiAuthGuard sends the person to the login screen,
// and a banner about it on the way out is noise" — true on a staff screen, and
// exactly false here, where the guard deliberately returns and does nothing.
//
// The result: a badge token that expired mid-shift produced a 401 carrying a
// sentence written for the worker — ״הזיהוי פג תוקף — יש לסרוק תג או לבחור
// מהרשימה שוב״ — and the kiosk showed nothing at all. The button simply stopped
// working. This is the same shape as the outage of 2026-08-28 that put this
// list here in the first place, one layer further in.
//
// So the rule lives in one file that both readers import, and a new door added
// later is added once.

/** Screens whose users are not staff and have no staff session to expire. */
// '/tv' — מסך הרצפה בטלוויזיה (11/10/2026): בלי משתמש, כמו הקיוסקים. בלעדיו 401
// של auth/me הפנה את הטלוויזיה למסך הכניסה (נתפס בדפדפן לפני הפריסה).
// '/photo/' — הדף שנפתח מ-QR (01/11/2026): טלפון בלי כניסה. ⚠ עם הלוכסן: בלעדיו
// נבלעת כל כתובת שמתחילה ב-photo, והמטרה היא דלת אחת.
export const NON_STAFF_AREAS = ['/scan', '/portal', '/field', '/tv', '/photo/'] as const;

export function isNonStaffArea(pathname: string): boolean {
  return NON_STAFF_AREAS.some((p) => pathname.startsWith(p));
}
